/**
 * Asynchronously loads the component for UpcomingEventWidgetContainer
 */
import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./UpcomingEventWidgetContainer'),
  loading: () => null,
});
